import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import { PrimaryButton, Icon, TimePicker, DLTextField } from 'appSrc/components/UI';
import { FormTextField, FormToggle } from 'appSrc/components/UI/ReduxForm';
import { digitizeDuration, validateWebUrl } from 'appSrc/utils';
import moment from 'moment-timezone';
import style from './styles/style.module.css';


const timeProps = {
    use12Hours: true,
    showSecond: false,
    format: 'hh:mm A',
};
const validate = {
    required: ( value ) => ( ( value == null || !/\S/.test( value ) ) ? 'Required' : undefined ),
    url: ( value ) => ( !!value && !validateWebUrl( value ) ? 'Invalid URL': undefined ),
};


class StepScheduleEdit extends Component {
    constructor( props ) {
        super( props );

        var initState = this.generateInitialState();


        this.state = { ...initState };
        this.flipped = false;
    }
    componentDidUpdate( prevProps ) {
        if( !this.flipped && prevProps.step === 'edit_video' && this.props.step === 'edit_schedule' ) {
            this.flipped = true;
            this.props.initialize( this.props.initialValues, true );
            this.setState( { ...this.generateInitialState() } );
        }
    }
    generateInitialState = () => {
        var initState = {};

        var runDate;
        if( this.props.initialValues.run_date ) {
            runDate = moment.tz( this.props.initialValues.run_date, 'MM/DD/YYYY', 'America/Chicago' );
        } else {
            runDate = moment.tz();
        }

        if( this.props.initialValues.start_time ) {
            initState.start_time = moment.tz( this.props.initialValues.start_time, 'America/Chicago' )
            .years( runDate.years() ).dayOfYear( runDate.dayOfYear() ).startOf( 'minute' );
        } else {
            initState.start_time = runDate.clone().hour( 9 ).startOf( 'hour' );
        }

        if( this.props.initialValues.duration && this.props.initialValues.duration !== 'P0D' ) {
            initState.durationLock = true;
            initState.durationWarn = null;
            initState.duration = moment.duration( this.props.initialValues.duration );
        }


        if( this.props.initialValues.end_time ) {
            initState.end_time = moment.tz( this.props.initialValues.end_time, 'America/Chicago' )
            .years( runDate.years() ).dayOfYear( runDate.dayOfYear() );
        } else if( initState.durationLock ) {
            initState.end_time = initState.start_time.clone().add( initState.duration.asMilliseconds(), 'ms' );
        } else {
            initState.end_time = initState.start_time.clone().add( 1, 'h' );
        }
        initState.end_time.add( 1, 'minute' ).startOf( 'minute' );

        if( !initState.durationLock )  {
            initState.durationLock = false;
            initState.durationWarn = 'Best Guess Duration';
            initState.duration = moment.duration( initState.end_time.diff( initState.start_time ) );
        }
        initState.durationStr = digitizeDuration( initState.duration );

        return initState;
    }
    toggleDurationLock = () => {
        this.setState( { durationLock: !this.state.durationLock } );
    }
    updateStartTime = ( value ) => {
        let newState = { start_time: value };
        if( this.state.durationLock ) {
            newState.end_time = value.clone().add( this.state.duration.asMilliseconds(), 'ms' );
        } else {
            newState.duration = moment.duration( this.state.end_time.diff( value ) );
        }
        this.setState( newState );
    }
    updateDuration = ( e, { value } ) => {
        let newState = { durationStr: value };
        newState.durationWarn = null;

        let dur = moment.duration( value );
        if( dur.isValid() && dur.asMilliseconds() !== 0 ) {
            newState.duration = dur;
            newState.durationError = false;
            newState.end_time = this.state.start_time.clone().add( Math.ceil( dur.asMinutes() ), 'm' );
        } else {
            newState.durationError = 'Invalid format';
        }

        this.setState( newState );
    }
    updateEndTime = ( value ) => {
        let newState = { end_time: value };
        newState.duration = moment.duration( value.diff( this.state.start_time ) );
        newState.durationStr = digitizeDuration( newState.duration );
        this.setState( newState );
    }
    toggleHidden = ( evt, checked ) => {
        if( checked ) {
            this.props.dispatch( change( 'StepScheduleEditForm', 'should_persist', false, true ) );
        }
    }
    togglePersist = ( evt, checked ) => {
        if( checked ) {
            this.props.dispatch( change( 'StepScheduleEditForm', 'is_hidden', false, true ) );
        }
    }

    submit = ( values ) => {
        const state = this.state;
        var ret = {
            block: {
                start_time: state.start_time.clone().utc().format(),
                end_time: state.end_time.clone().utc().format(),
                category: values.category,
                is_hidden: values.is_hidden,
                should_persist: values.should_persist,
                donation_link: values.donation_link,
                sponser: values.sponser,
                sponser_link: values.sponser_link,
            },
            video: {
                related_content_link: values.related_content_link,
                duration: state.duration.toISOString(),
            },
        };

        this.props.onSubmit( ret );
    }



    render() {
        const { handleSubmit, valid } = this.props;
        const { start_time, end_time, durationLock, durationError } = this.state;

        const isValid = valid && !durationError;

        const inlineStyle = this.props.step !== 'edit_schedule' ? { display: 'none' } : {};


        return (
            <Form className={ style.scheduleEditForm } style={ inlineStyle }
            onSubmit={ handleSubmit( this.submit ) }>
                <h2>Schedule Information</h2>
                <p>Where should this block go in the schedule?</p>
                <br/>
                <div className={ style.grid }>
                    <div>
                        <div className={ style.timeField } >
                            <div className={ style.fieldTitle }>Start Time</div>
                            <TimePicker { ...timeProps } value={ start_time }
                            onChange={ this.updateStartTime } />
                        </div>

                        <div className={ style.durationWrapper }>
                            <DLTextField label='Duration'
                            disabled={ durationLock }
                            onChange={ this.updateDuration }
                            value={ this.state.durationStr }
                            error={ durationError || this.state.durationWarn } />
                            <div className={ style.durationLock } onClick={ this.toggleDurationLock }
                            title='Click to toggle duration lock'>
                                <Icon source='fontAwesome' icon={ durationLock ? 'fas/faLock' : 'fas/faLockOpen' } />
                            </div>
                        </div>

                        <div className={ style.timeField } >
                            <div className={ style.fieldTitle }>End Time</div>
                            <TimePicker { ...timeProps } value={ end_time } disabled={ durationLock }
                            onChange={ this.updateEndTime } />
                        </div>

                        <Field
                        id="category"
                        name="category"
                        label="Category"
                        component={ FormTextField } />

                        <Field
                        id="is_hidden"
                        name="is_hidden"
                        label="Hide on Schedule?"
                        style={ { marginTop: '15px', zIndex: 0 } }
                        component={ FormToggle } />

                        <Field
                        id="should_persist"
                        name="should_persist"
                        label="Persist?"
                        style={ { marginTop: '15px', zIndex: 0 } }
                        component={ FormToggle } />
                    </div>
                    <div>
                        <Field
                        id="donation_link"
                        name="donation_link"
                        label="Donation Link"
                        fullWidth
                        validate={ [ validate.url ] }
                        component={ FormTextField } />

                        <Field
                        id="related_content_link"
                        name="related_content_link"
                        label="Related Content Link"
                        fullWidth
                        validate={ [ validate.url ] }
                        component={ FormTextField } />

                        <div className={ style.spacer } />

                        <Field
                        id="sponser"
                        name="sponser"
                        label="Sponser"
                        fullWidth
                        component={ FormTextField } />

                        <Field
                        id="sponser_link"
                        name="sponser_link"
                        label="Sponser Link"
                        fullWidth
                        validate={ [ validate.url ] }
                        component={ FormTextField } />
                    </div>
                </div>

                <div className={ style.buttonGroup } style={ { marginTop: '25px', zIndex: 0 } }>
                    <PrimaryButton
                    label="Back"
                    fullWidth reverse
                    onClick={ () => { this.props.onSubmit( false ); } } />
                    <PrimaryButton
                    label="Submit"
                    type="submit"
                    fullWidth
                    disabled={ !isValid } />
                </div>
            </Form>
        );
    }
}
StepScheduleEdit.defaultProps = {
    onSubmit: () => {},
};

StepScheduleEdit = reduxForm( {
    form: 'StepScheduleEditForm',
} )( StepScheduleEdit );



export default connect()( StepScheduleEdit );
